import TextObject from "./TextObject";

class MaxWidthTextObject extends TextObject {

    static TYPE_TITLE = 'mwtext';

    /**
     * If the text grows over this width, the font size is reduced.
     */
    _maxWidth;
    _maxWidthIsManipulable;

    /**
     * Create a TextboxObject.
     * @param {Canvas} canvas Instance of the canvas on which the object is displayed.
     * @param {string} content The content of the text element.
     */
    constructor(canvas, content) {
        super(canvas, content);

        this._maxWidth = null;
        this._maxWidthIsManipulable = true;
    }

    async setText(value) {

        super.setText(value);

        const canvasObject = await this.createFabricObject();

        console.log('set text of limited text element ------------ ', canvasObject.width, this.getMaxWidth());

        if (canvasObject.getScaledWidth() > this.getMaxWidth()) {

            console.log('set text of limited text element >>>>>>>>>> ', canvasObject.width, this.getMaxWidth());

            this.setFontSize(
                this.getFontSize() * ( this.getMaxWidth() / (canvasObject.width + 1) )
            );

        }

    }

    /**
     * Object that is passed in JSON format to the API when saving the CanvasObject.
     * @returns {Object}
     */
    createObjectForSaveRequest() {

        const result = super.createObjectForSaveRequest();

        result.type = this.constructor.TYPE_TITLE;
        result.maxWidth = {
            value: this.getMaxWidth(),
            manipulable: this.getMaxWidthIsManipulable()
        };

        return result;

    }

    /**
     * Each type of object can define its own view in which controls are defined for the object.
     * @returns {string} Filename
     */
    getViewInObjectsConfigurator() {

        return 'MaxWidthTextCanvasObject.vue';

    }

    /**
     * @return {number}
     */
    getMaxWidth() {
        return this._maxWidth;
    }

    /**
     * @return {number}
     */
    getMaxWidthInMm() {
        return this.getCanvas().convertPixelToMm(this._maxWidth);
    }

    /**
     * @param {number} value
     */
    setMaxWidth(value) {
        this._maxWidth = value;
    }

    /**
     * @param {number} value
     */
    setMaxWidthInMm(value) {
        this._maxWidth = this.getCanvas().convertMmInPixel(value);
    }

    /**
     * @param {boolean} value
     */
    setMaxWidthIsManipulable(value) {
        this._maxWidthIsManipulable = value;
    }

    /**
     * @return {boolean}
     */
    getMaxWidthIsManipulable() {
        return this._maxWidthIsManipulable;
    }


}

export default MaxWidthTextObject;